import React from 'react';

import ReviewCard from '../ReviewCard';
import ClutchCard from '../ClutchCard';
import {
  About,
  AboutSticky,
  Cards,
  Description,
  Inner,
  SpanTitle1,
  SpanTitle2,
  Title,
  Wrapper,
} from './reviews.styles';

export const Reviews = ({ data, titleAs }: any) => {
  return (
    <Wrapper>
      <Inner>
        <About>
          <AboutSticky>
            <Title as={titleAs}>
              <SpanTitle1>{data.title}</SpanTitle1>
              <SpanTitle2>{data.title2}</SpanTitle2>
            </Title>
            <Description>{data.description}</Description>
          </AboutSticky>
        </About>
        <Cards>
          {data.reviews.map((review: any, index: number) => (
            <ReviewCard
              key={index}
              name={review.reviewer_name}
              company={review.reviewer_company}
              position={review.reviewer_position}
              photo={review.reviewer_photo}
              quote={review.review_text}
            />
          ))}
          <ClutchCard text={data.clutch} />
        </Cards>
      </Inner>
    </Wrapper>
  );
};
